import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal';

/* Icons */
import crossIcon from 'symbols/cross.svg';

/* Common */
import { Icon } from 'js/components/atoms';

/* Utilities */
import { trans } from 'js/utilities';

export default function Modal(props) {
    const {
        open,
        handleClose,
        className,
        title = '',
        centered = true,
        header = (
            <>
                <p className="modal-title text--14 text-base">{title}</p>
                <button className="modal-header__close close" title={trans('sulu.modal.header.close.title')} aria-label={trans('sulu.modal.header.close.title')} onClick={handleClose}>
                    <Icon url={crossIcon} size={24} />
                </button>
            </>
        ),
        bodyTitle,
        bodyContent,
        footer,
        bootstrapFooter,
        children,
        theme,
        ...passProps
    } = props;

    return (
        <BootstrapModal
            show={open}
            onHide={handleClose}
            className={className}
            centered={centered}
            {...passProps}
        >
            <BootstrapModal.Header>{header}</BootstrapModal.Header>
            <BootstrapModal.Body>
                {bodyContent ? (
                    <div className={`mt-n6 ${!theme ? 'bg-base' : ''}`} style={{ backgroundColor: theme ? theme : 'inherit' }}>
                        {bodyContent}
                    </div>
                ) : bodyTitle && (
                    <div className={`d-flex align-content-center p-6 p-md-12 mt-n6 mb-6 mb-md-12 ${!theme ? 'bg-base' : ''}`} style={{ backgroundColor: theme ? theme : 'inherit' }}>
                        <h3 className="text-white">{bodyTitle}</h3>
                    </div>
                )}
                <div className="container">
                    {children}
                </div>
                {footer && <div className="modal-footer-content">{footer}</div>}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>{bootstrapFooter}</BootstrapModal.Footer>
        </BootstrapModal>
    );
}
